import { INSPECTION_TRIGGERS } from "@repo/shared/inspectionTriggers";
import * as Schema from "effect/Schema";
const NullableText = Schema.NullOr(Schema.String);
const Count = Schema.Number.check(Schema.isInt(), Schema.isGreaterThanOrEqualTo(0));
export const InspectionRunSchema = Schema.Struct({
  threadId: Schema.String,
  title: Schema.String,
  trigger: Schema.NullOr(Schema.Literals(INSPECTION_TRIGGERS)),
  status: Schema.Literals(["queued", "running", "completed", "failed", "interrupted"]),
  startedAt: Schema.String,
  completedAt: NullableText,
  summary: NullableText,
  error: Schema.optionalKey(NullableText),
  found: Schema.Struct({
    suggestions: Count,
    findings: Count,
    publications: Count,
    revised: Count,
    withdrawn: Count,
  }),
  reply: Schema.optionalKey(
    Schema.NullOr(Schema.Struct({ text: Schema.String, createdAt: Schema.String })),
  ),
  // Which document a re-assessment re-reads, and between which captured text versions.
  reassessment: Schema.optionalKey(
    Schema.NullOr(
      Schema.Struct({
        policyId: Schema.String,
        fromVersion: Schema.NullOr(Count),
        toVersion: Schema.NullOr(Count),
      }),
    ),
  ),
  review: Schema.optionalKey(
    Schema.NullOr(
      Schema.Struct({
        findingId: Schema.String,
        policyId: Schema.String,
        requestId: NullableText,
        instruction: NullableText,
      }),
    ),
  ),
});
export const InspectionItemsSchema = Schema.Struct({
  suggestions: Schema.Array(
    Schema.Struct({
      id: Schema.String,
      kind: Schema.String,
      title: Schema.String,
      severity: NullableText,
      status: Schema.String,
      policyId: NullableText,
      policyName: NullableText,
    }),
  ),
  findings: Schema.Array(
    Schema.Struct({
      id: Schema.String,
      title: Schema.String,
      severity: NullableText,
      status: Schema.String,
      policyId: Schema.String,
      policyName: NullableText,
    }),
  ),
  publications: Schema.Array(
    Schema.Struct({
      id: Schema.String,
      title: Schema.String,
      kind: NullableText,
      applicability: NullableText,
      publishedAt: NullableText,
    }),
  ),
  activity: Schema.Array(
    Schema.Struct({
      kind: Schema.String,
      detail: Schema.String,
      policyId: Schema.String,
      createdAt: Schema.String,
    }),
  ),
});
export const InspectionDetailSchema = Schema.Struct({
  run: InspectionRunSchema,
  messages: Schema.Array(
    Schema.Struct({ role: Schema.String, text: Schema.String, createdAt: Schema.String }),
  ),
  report: NullableText,
  items: InspectionItemsSchema,
});
export const InspectionListSchema = Schema.Struct({
  runs: Schema.Array(InspectionRunSchema),
  scheduled: Schema.optionalKey(Schema.NullOr(Schema.Struct({ at: Schema.String }))),
});
export type InspectionRun = typeof InspectionRunSchema.Type;
export type InspectionReassessment = NonNullable<InspectionRun["reassessment"]>;
export type InspectionDetail = typeof InspectionDetailSchema.Type;
export type InspectionItems = typeof InspectionItemsSchema.Type;
export const decodeInspectionList = Schema.decodeUnknownSync(InspectionListSchema);
export const decodeInspectionDetail = Schema.decodeUnknownSync(InspectionDetailSchema);

export const inspectionActive = (run: Pick<InspectionRun, "status">) =>
  run.status === "queued" || run.status === "running";
